<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup" *ngIf="model === 'undefined'">
  <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
    <span>
      {{ 'HOTEL_SELECT.HOTEL' | translate }}
    </span>

    <span *ngIf="parentFormGroup.get(passFormControlName).value">
      <button type="button" class="btn btn-ico btn-link" (click)="edit()">
        <i class="fal fa-pencil"></i>
      </button>
    </span>
  </div>

  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    [items]="data | async"
    bindLabel="name"
    bindValue="id"
    [loading]="loader"
    [formControlName]="passFormControlName"
    [typeahead]="input$"
    (change)="change($event)"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="hotel-select-option-wrapper">
        <div class="hotel-name">{{ item.name }}</div>
        <div class="hotel-city" *ngIf="item.city">{{ item.city.name }},</div>
        <div class="hotel-country" *ngIf="item.city?.country">{{ item.city.country.name }}</div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'HOTEL_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
    <ng-select
      [items]="data | async"
      bindLabel="name"
      bindValue="id"
      appendTo="body"
      [loading]="loader"
      [formControlName]="passFormControlName"
      [typeahead]="input$"
      (change)="change($event)"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div class="hotel-select-option-wrapper">
          <div class="hotel-name">{{ item.name }}</div>
          <div class="hotel-city" *ngIf="item.city">{{ item.city.name }},</div>
          <div class="hotel-country" *ngIf="item.city?.country">{{ item.city.country.name }}</div>
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'HOTEL_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-template>
</div>

<div class="form-group" *ngIf="model !== 'undefined'">
  <label>{{ 'HOTEL_SELECT.HOTEL' | translate }}</label>
  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    [items]="data | async"
    bindLabel="name"
    [loading]="loader"
    [(ngModel)]="model"
    (change)="changeModel($event)"
    [typeahead]="input$"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="hotel-select-option-wrapper">
        <div class="hotel-name">{{ item.name }}</div>
        <div class="hotel-city" *ngIf="item.city">{{ item.city.name }},</div>
        <div class="hotel-country" *ngIf="item.city?.country">{{ item.city.country.name }}</div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'HOTEL_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
    <ng-select
      [items]="data | async"
      bindLabel="name"
      appendTo="body"
      [loading]="loader"
      [(ngModel)]="model"
      (change)="changeModel($event)"
      [typeahead]="input$"
    >
      <ng-template ng-typetosearch-tmp>
        <div class="ng-option disabled">
          {{ 'START_TYPING' | translate }}
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div class="hotel-select-option-wrapper">
          <div class="hotel-name">{{ item.name }}</div>
          <div class="hotel-city" *ngIf="item.city">{{ item.city.name }},</div>
          <div class="hotel-country" *ngIf="item.city?.country">{{ item.city.country.name }}</div>
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <div class="ng-option disabled">
          <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
          <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
            <i class="fal fa-plus"></i> {{ 'HOTEL_SELECT.ADD' | translate }}
          </button>
        </div>
      </ng-template>
    </ng-select>
  </ng-template>
</div>
